import { render } from "./AddMateriel.vue?vue&type=template&id=e72572e2"
import script from "./AddMateriel.vue?vue&type=script&lang=js"
export * from "./AddMateriel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__